var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.userInfo().is_wholesale_onbehalf_ok)?_c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('InfoBlock',{attrs:{"type":"dialog"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }